import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";

interface NewsHighlightsProps {
  items: NewsItem[];
}

export default function NewsHighlights({ items }: NewsHighlightsProps) {
  const [first, ...rest] = items;
  if (!first) return null;

  return (
    <section className="bg-background-100 px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6 md:mb-8">
          <div>
            <span className="text-xs tracking-[0.22em] uppercase text-secondary-600">Latest News</span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mt-2">最新影视资讯</h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-xl">行业动态、幕后花絮与主创独家采访，每天都有新的故事在银幕之外发生。</p>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            全部资讯
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          <NewsCard item={first} variant="feature" />
          <div className="flex flex-col justify-center bg-background-50 rounded-lg px-4 md:px-6">
            {rest.map((item) => (
              <NewsCard key={item.id} item={item} variant="horizontal" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}